// ============================================================
// Unread (v8.363.1): a line counts when it is not mine, not removed,
// and newer than the last time I read its conversation. Pure.
// ============================================================
import type { ChatMessage, ConversationKey } from './types';
import { conversationOf } from './audience';

export interface Unread {
  byConv: Partial<Record<ConversationKey, number>>;
  total: number;
}

export function unreadCounts(messages: ChatMessage[], lastReadAt: Partial<Record<string, number>>, me: string): Unread {
  const byConv: Partial<Record<ConversationKey, number>> = {};
  let total = 0;
  for (const m of messages) {
    const key = unreadIn(m, lastReadAt, me);
    if (key === null) continue;
    byConv[key] = (byConv[key] ?? 0) + 1;
    total += 1;
  }
  return { byConv, total };
}

/** The conversation this message is unread in, or null: mine, removed, and already-read do not count. */
function unreadIn(m: ChatMessage, lastReadAt: Partial<Record<string, number>>, me: string): ConversationKey | null {
  if (m.fromUid === me || m.kind === 'removed') return null;
  const key = conversationOf(m, me);
  return m.ts <= (lastReadAt[key] ?? 0) ? null : key;
}
